var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"about",attrs:{"to":{ name: 'about'},"tag":"div"}},[_c('div',{staticClass:"inner"},[_c('span',[_vm._v("About")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }